import { apiClient } from "@/api/client";
import type { Paginated } from "@/types/common";
import type { PayoutRow, PayoutStatus } from "@/types/domain";

/** Driver withdrawals. Approve = send the money through the payment provider. */
export const payoutsApi = {
  list: (params: { status?: PayoutStatus; page?: number; limit?: number }) =>
    apiClient.get<Paginated<PayoutRow>>("/admin/payouts", { params }).then((r) => r.data),
  approve: (id: string) => apiClient.post<PayoutRow>(`/admin/payouts/${id}/approve`).then((r) => r.data),
  reject: (id: string, reason: string) =>
    apiClient.post<PayoutRow>(`/admin/payouts/${id}/reject`, { reason }).then((r) => r.data),
  markPaid: (id: string, reference: string) =>
    apiClient.patch<PayoutRow>(`/admin/payouts/${id}/paid`, { reference }).then((r) => r.data),
};
